module.exports = __webpack_public_path__ + "img/21.82525f51.png";